import { combineReducers, configureStore } from '@reduxjs/toolkit';
import cartReducer from 'slices/cartSlice';
import comparisonReducer from 'slices/comparisonSlice';
import convenienceVariablesReducer from 'slices/convenienceVariablesSlice';
import availabilityReducer from 'slices/availabilitySlice';
import doctorReducer from 'slices/doctorSlice';
import dynamicValueReducer from 'slices/dynamicSlice';
import eligibilityReducer from 'slices/eligibilitySlice';
import locationReducer from 'slices/locationSlice';
import mediaReducer from 'slices/mediaSlice';
import navigationReducer from 'slices/navigationSlice';
import planSelectionReducer from 'slices/planSelectionSlice';
import prescriptionReducer from 'slices/prescriptionSlice';
import pharmacyReducer from 'slices/pharmacySlice';
import recommendationReducer from 'slices/recommendationSlice';
import userReducer from 'slices/userSlice';

const rootReducer = combineReducers({
  availability: availabilityReducer,
  cart: cartReducer,
  comparison: comparisonReducer,
  convenienceVariables: convenienceVariablesReducer,
  doctor: doctorReducer,
  dynamicValues: dynamicValueReducer,
  eligibility: eligibilityReducer,
  location: locationReducer,
  media: mediaReducer,
  navigation: navigationReducer,
  planSelection: planSelectionReducer,
  prescription: prescriptionReducer,
  pharmacy: pharmacyReducer,
  recommendation: recommendationReducer,
  user: userReducer,
});

export type PreloadedAppState = Partial<ReturnType<typeof rootReducer>>;

export const makeStore = (preloadedState?: PreloadedAppState) =>
  configureStore({
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware();
    },
    reducer: rootReducer,
    preloadedState,
    devTools: process.env.CURRENT_ENVIRONMENT !== 'production',
  });

export type AppDispatch = AppStore['dispatch'];
// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
